import React from "react"
import {Link} from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Button from "../components/button"

import introMotion from "../../content/assets/introMotion.mp4"


class IndexPage extends React.Component {

  render() {
    const siteTitle = "Chaotic linkage";
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Home"
          keywords={[`blog`, 'julien', 'brissonneau', 'chaotic', 'linkage', `gatsby`, `javascript`, `react`]}
        />
        <div style={{textAlign: 'center'}}>
          <div style={{display: "inline-block", marginLeft: '20px'}}>
            <Link to="/blog/" style={{textDecoration: 'none', color: 'white'}}>
              <video muted autoPlay preload="metadata"
                     style={{
                       width: `80%`,
                       marginTop: '-30px',
                       height: '466px',
                       marginBottom: '-70px',
                       zIndex: -1,
                       position: 'fixed',
                       top: '11%',
                       left: '11%',
                     }}>
                <source src={introMotion + "#t=0.1"} type="video/mp4"/>
              </video>
            </Link>
          </div>
        </div>


        <p style={{textAlign: 'center', marginTop: '63%'}}>
          Random thoughts, organized in posts.
        </p>
        <Link to="/blog/">

          <div style={{textAlign: 'center', marginTop: '5%',}}>
            <div style={{display: "inline-block"}}>
              <Button>Go to Blog</Button>
            </div>
          </div>
        </Link>
        <a target="_blank" rel="noopener noreferrer" href="https://www.buymeacoffee.com/w2TItqd">
          <p style={{textAlign: 'center', marginTop: '5%'}}>
            <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"/>
          </p>
        </a>
        <div style={{textAlign: 'center', marginTop: '5%'}}>
          <div style={{display: "inline-block"}}>
            <div>
              <a target="_blank" rel="noopener noreferrer" href="https://www.buymeacoffee.com/w2TItqd">
                <Button style={{height: '60px'}}>
                  <span>Buy me a coffee</span>
                </Button>
              </a>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default IndexPage
